// extracted by mini-css-extract-plugin
export var image = "_j3-1";
export var imageContainer = "_j3-0";